const rankings = [
  { rank: 1, title: '绝世武魂', genre: '玄幻国漫', heat: '9.8', status: '连载中', icon: 'ri-medal-line' },
  { rank: 2, title: '我的野蛮王妃', genre: '恋爱韩漫', heat: '9.7', status: '连载中', icon: 'ri-medal-line' },
  { rank: 3, title: '斗破苍穹', genre: '玄幻国漫', heat: '9.6', status: '连载中', icon: 'ri-medal-line' },
  { rank: 4, title: '进击的巨人', genre: '热血日漫', heat: '9.5', status: '已完结', icon: 'ri-star-line' },
  { rank: 5, title: '完美世界', genre: '奇幻国漫', heat: '9.4', status: '连载中', icon: 'ri-star-line' },
  { rank: 6, title: '某天成为公主', genre: '宫廷韩漫', heat: '9.3', status: '连载中', icon: 'ri-star-line' },
  { rank: 7, title: '鬼灭之刃', genre: '热血日漫', heat: '9.2', status: '已完结', icon: 'ri-star-line' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              <i className="ri-fire-line text-sm"></i>
              实时热度榜
            </div>
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 mb-3">
              热门排行榜
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              基于阅读热度与读者口碑综合排名的漫画榜单，每周实时更新
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 gap-3 md:gap-4">
            {rankings.map((item, i) => (
              <a
                key={i}
                href="#ranking"
                className="group flex lg:flex-col items-center lg:items-start gap-4 lg:gap-0 bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5 hover:border-accent-300 transition-all cursor-pointer"
              >
                <div className="flex-shrink-0 w-10 h-10 lg:w-12 lg:h-12 lg:mb-4 flex items-center justify-center rounded-xl text-lg lg:text-xl font-extrabold bg-background-100 text-foreground-300 group-hover:bg-accent-100 group-hover:text-accent-600 transition-all">
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0 lg:w-full">
                  <h3 className="text-sm font-bold text-foreground-900 truncate mb-1">{item.title}</h3>
                  <p className="text-xs text-foreground-500 mb-2">{item.genre}</p>
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-semibold text-accent-600">
                      <i className={`${item.icon} text-[10px] mr-0.5`}></i>
                      {item.heat}
                    </span>
                    <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-medium ${
                      item.status === '连载中'
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.status}
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}